// extracted by css-extract-rspack-plugin
export default {"modal":"UhVroiEvumIGd5PD","content":"LUXHenO4YlIgSg0D"};